// Modules
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment';
import DOMPurify from 'dompurify';

// CSS
import '_Asset/css/Admin/Page/admin.css'

// Component
import { Pagination } from 'User/Component';
import {
  CurPageList,
  Paging, // Paging
  SetSortIco, // 정렬 아이콘 변경
} from 'Admin/Component/AdFunc';
import Loading from 'Admin/Component/Loading';
import ReceiptPopUp from 'Admin/Component/ReceiptPopUp';

// API
import { ApprHistoryApi } from '_Route/Api';


const AdReceipt = () => {

  // Using Hooks
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [guideStatus, setGuideStatus] = useState(true);
  const [popUpState, setPopUpState] = useState(false)
  const [aprvPageData, setAprvPageData] = useState([]); // Aprv Page Data
  const [aprvData, setAprvData] = useState([]); // Aprv List Data
  const [curAprvData, setCurAprvData] = useState([]);
  
  const sessionID = localStorage.getItem('memSessionID')
  const userScore = useSelector(state => state.authorityAcc.access_score);
  // const userRoles = useSelector(state => state.authorityAcc.roles);
  
  // 필터 옵션
  const [filterOpt, setFilterOpt] = useState({
    search_key: '',
    search_val: params.key || '',
    approve_status: '',
    approve_req_date: '',
    approve_suc_date: '',
  })
  const { search_key, search_val, approve_status, approve_req_date, approve_suc_date } = filterOpt
  
  // Paging var
  const [curPage, setCurPage] = useState(1) // 현제 페이지
  const blockSize = 10 // Pagination 블럭 갯수
  const [pageSize, setPageSize] = useState(10) // 한 페이지에 노출할 회원 갯수


  // Column name / Sort var
  const columnList = [
    {name: 'No', key: 'approve_no'},
    {name: '요청유형', key: 'approve_req_cat'}, 
    {name: '요청자', key: 'approve_req'},
    {name: '검토자', key: 'approve_spec'},
    {name: '승인자', key: 'approve_ap'},
    {name: '처리상태', key: 'approve_status'},
    {name: '요청일', key: 'approve_req_date'},
    {name: '완료일', key: 'approve_suc_date'},
  ]; 
  
  const [sortIdx, setSortIdx] = useState(0);
  const [sortType, setSortType] = useState('');
  const [sortState, setSortState] = useState('expand'); // expand, up(DECS), down(ASC);


  /*========================================================================
  * onHandler Func
  ========================================================================*/
  const onFilter = (e) => {
    const { name, value } = e.target;
    setFilterOpt({...filterOpt, [name]: value});
  }

  const onKeyPress = (e) => { if(e.key == 'Enter') onSearch(); }
  const onSearch = () => {
    navigate(`/admin/review-aprv/receipt${search_val === '' ? '' : '/' + encodeURIComponent(search_val)}`);
  }


  /* ========================================================================
  * Axios History
  ========================================================================*/
  // GET History List
  useEffect(() => {
    setLoading(false)
    axios({
      url: ApprHistoryApi,
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      params: filterOpt
    })
    .then(res => {
      // console.log("GET Approver History List Success", res);
      const sortData = res.data.result;
      
      setAprvPageData(res.data.pageInfo)
      setAprvData(CurPageList(sortData, sortType, sortState, curPage, pageSize))
    })
    .catch(err => {
      console.error("GET Approver History List ERROR...", err);
    })
    .finally(() => {
      setLoading(true)
    })
  }, [location, pageSize, curPage, sortState, sortIdx, search_key, approve_status, approve_req_date, approve_suc_date])


  return (
    <>
      <div className="adContTitGroup">
        <h2>검토/승인 요청 조회</h2>
        <p>Home / 검토/승인 / 검토/승인 요청 조회 <button type="button" onClick={() => setGuideStatus(!guideStatus)}><i className="icofont-info-circle" /> 가이드 {guideStatus ? '접기' : '보기'} <i className={`icofont-rounded-${guideStatus ? 'up' : 'down'}`} /></button></p>

        <ul className={`subMsg ${guideStatus ? '' : 'off'}`}>
          <li>* 현재 요청자에게 들어온 모든 요청을 <span className="blueTxt">조회/검색</span>할 수 있습니다.</li>
          <li>* 요청 유형 항목을 클릭할시 해당 <span className="blueTxt">요청에 대한 정보를 확인</span>할 수 있습니다.</li>
        </ul>
      </div>

      <div className="adContArea list">
        <div className="flexBox end between">
          <div className="adListBox">
            <div className="fieldGroup">
              <label>노출 검토 수</label>

              <div className="field">
                <select className="select sm type_1 round_10" onChange={(e) => setPageSize(e.target.value)} defaultValue="10">
                  <option value="10">10개 씩</option>
                  <option value="30">30개 씩</option>
                  <option value="50">50개 씩</option>
                  <option value="100">100개 씩</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>처리상태</label>

              <div className="field">
                <select name="approve_status" className="select sm type_1 round_10" onChange={(e) => onFilter(e)}>
                  <option value="">전체</option>
                  <option value="미완료">미완료</option>
                  <option value="검토완료">검토완료</option>
                  <option value="승인완료">승인완료</option>
                  <option value="반영완료">반영완료</option>
                  <option value="요청반려">요청반려</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>요청일</label>

              <div className="field">
                <select className="select sm type_1 round_10" name="approve_req_date" onChange={(e) => onFilter(e)}>
                  <option value="">전체</option>
                  <option value="to">오늘</option>
                  <option value="day">어제</option>
                  <option value="week">최근 1주일</option>
                  <option value="month">최근 1개월</option>
                  <option value="year">최근 1년</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>완료일</label>

              <div className="field full">
                <select className="select sm type_1 round_10" name="approve_suc_date" onChange={(e) => onFilter(e)}>
                  <option value="">전체</option>
                  <option value="to">오늘</option>
                  <option value="day">어제</option>
                  <option value="week">최근 1주일</option>
                  <option value="month">최근 1개월</option>
                  <option value="year">최근 1년</option>
                </select>
              </div>
            </div>
          </div>

          <div className="adListBox">
            <div className="fieldGroup row gap">
              <label>검토/승인 요청 검색</label>

              <div className="field gap">
                <select className="select sm type_1 round_10" name="search_key" onChange={(e) => onFilter(e)}>
                  <option value="">통합검색</option>
                  <option value="approve_req_cat">요청유형</option>
                  <option value="approve_req">요청자</option>
                  <option value="approve_spec">검토자</option>
                  <option value="approve_ap">승인자</option>
                </select>
                <div className="inputIco">
                  <input type="text" name="search_val" className="input sm type_1 i_rt round_10" value={search_val} onChange={(e) => onFilter(e)} onKeyPress={onKeyPress} placeholder="검색어를 입력해주세요." />
                  <button type="button" className="icofont-search" onClick={onSearch}></button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="table list_2">
          <table>
            <thead>
              <tr>
                {columnList.map((list, i) =>
                  <th key={i} onClick={() => {setSortState(SetSortIco(i, sortIdx, sortState)); setSortIdx(i); setSortType(list.key)}}>{list.name}<i className={`icofont-rounded-${i === sortIdx ? sortState : 'expand'}`}></i></th>
                )}
              </tr>
            </thead>
            <tbody>
              {loading ?
                aprvData.length !== 0 ?
                  aprvData.map((data, i) => 
                    <tr key={i}>
                      <td>{data.approve_no}</td>
                      <td><button type="button" style={{textDecoration: 'underline'}} onClick={() => {setPopUpState(true); setCurAprvData(data)}}>{data.approve_req_cat}</button></td>
                      <td>{data.approve_req}</td>
                      <td>{data.approve_spec}</td>
                      <td>{data.approve_ap}</td>
                      <td className={`status_${data.approve_status_int}`}>{data.approve_status}</td>
                      <td>{moment(data.approve_req_date).format('YYYY-MM-DD HH:mm')}</td>
                      <td>{data.approve_suc_date === null ? '-' : moment(data.approve_suc_date).format('YYYY-MM-DD HH:mm')}</td>
                    </tr>
                  )
                  :
                  <tr>
                    <td colSpan={columnList.length + 1}>
                      <div className="noData">
                        <i className="icofont-warning-alt"></i>
                        <p>데이터가 존재하지 않습니다.</p>
                      </div>
                    </td>
                  </tr>
                :
                <tr><td colSpan={columnList.length + 1}><Loading type="tbLoad" /></td></tr>
              }
            </tbody>
          </table>
        </div>

        <div className="flexBox between paginationBox">
          <p>Showing {curPage} to {pageSize} of {aprvPageData?.count} entries</p>

          <Pagination
            type="type_1"
            size="sm"
            curPage={curPage}
            setCurPage={setCurPage}
            pageSize={pageSize}
            blockSize={blockSize}
            startBlock={Paging(curPage, blockSize, pageSize, aprvPageData?.count).startBlock}
            endBlock={Paging(curPage, blockSize, pageSize, aprvPageData?.count).endBlock}
            pageCount={Paging(curPage, blockSize, pageSize, aprvPageData?.count).pageCount}
          />
        </div>
      </div>
      
      {/* 요청 유형 팝업 */}
      <ReceiptPopUp
        popUpState={popUpState}
        setPopUpState={setPopUpState}
        curData={curAprvData}
      />
    </>
  )
}

export default AdReceipt